export default function Getdata() {
    let result_list = window.localStorage.getItem('list_item');
    if(result_list) {
        return JSON.parse(result_list);
    }
    window.localStorage.setItem('list_item',JSON.stringify([]));
    return [];
    
}